import ApiClient from '@afosto/api/ApiClient';

class Locations {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create a new location
   *
   * @param {Object} body - Location model
   * @param {Object} options - The additional request options
   * @description A location is a reference to a warehouse
   * @returns {Promise}
   */
  createLocation(body, options = {}) {
    return this.apiClient.request({
      url: `/wms/locations`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Mark a location as deleted
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Mark a location as deleted
   * @returns {Promise}
   */
  deleteLocation(id, options = {}) {
    return this.apiClient.request({
      url: `/wms/locations/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get a location
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get a location
   * @returns {Promise}
   */
  getLocation(id, options = {}) {
    return this.apiClient.request({
      url: `/wms/locations/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a list of locations
   *
   * @param {Object} query - The optional path parameters
   * @param {Number} [query.deletedAt] - the timestamp to compare against
   * @param {Object} options - The additional request options
   * @description List existing locations
   * @returns {Promise}
   */
  listLocations(query = {}, options = {}) {
    const params = {
      deleted_at: query.deletedAt,
    };

    return this.apiClient.request({
      url: `/wms/locations`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Get a location
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description search a location for an address
   * @returns {Promise}
   */
  searchALocation(body, options = {}) {
    return this.apiClient.request({
      url: `/wms/search/locations`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Update the location
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update a location
   * @returns {Promise}
   */
  updateLocation(body, options = {}) {
    return this.apiClient.request({
      url: `/wms/locations`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const locations = new Locations();

export default Locations;
